"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const rfid_tag_dumptruck_types_1 = require("./rfid-tag-dumptruck.types");
const app_types_1 = require("../../../app.types");
const initialState = {
    isLoading: true,
    isError: false,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    mutationMode: false,
    dataItem: {
        id: '0',
        contractor_id: '',
        contractor_name: '',
        is_active: false,
        dumptruck_no: '',
        capacity_volume: 0,
        modified_by: '',
        modified_date: new Date(),
        created_date: new Date(),
        created_by: '',
        rfid_tag: '',
        dumptruck_spec: ''
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }]
    }
};
const rfidTagDumpTruckReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [rfid_tag_dumptruck_types_1.rfidTagDumpTruckTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [rfid_tag_dumptruck_types_1.rfidTagDumpTruckTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [rfid_tag_dumptruck_types_1.rfidTagDumpTruckTypes.SET_ERROR]: (state, action) => {
        const { errorCode, isError, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isError,
            errorCode,
            errorMessage, isLoading: false, isSuccess: false, isLoadingSubmit: false });
    },
    [rfid_tag_dumptruck_types_1.rfidTagDumpTruckTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess, isLoadingSubmit } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoadingSubmit, mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess });
    },
    [rfid_tag_dumptruck_types_1.rfidTagDumpTruckTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [rfid_tag_dumptruck_types_1.rfidTagDumpTruckTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { sort: action.payload }) });
    },
    [rfid_tag_dumptruck_types_1.rfidTagDumpTruckTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, isLoading: true, mutationMode: false, isLoadingSubmit: isSuccess, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === dataItem.id)
                    return dataItem;
                return item;
            }) });
    },
});
exports.default = rfidTagDumpTruckReducer;
